<template>
    <section id="smoothPkt-content">
        <div class="container">
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange">Pharmacokinetic Profile</span>
                <h1 class="gtitle fw-semibold">
                    Unique DR/ER layers of <span class="text-nowrap omnes">JORNAY PM</span> allow for colonic
                    absorption and smooth onset and offset of effect<sup class="omnes">1-3</sup></h1>
            </div>

            <div class="content limitations my-4">
                <div class="col-12 p-0">
                    <ul class="">
                        <li>The delayed-release layer limits delivery until the early morning with &lt;5% of total drug
                            available within the first 10 hours post dose<sup>4</sup>
                        </li>
                        <li>An extended-release layer controls delivery throughout the day<sup> 4</sup></li>
                    </ul>
                </div>
            </div>

            <div class="content img-container pl-0 pl-lg-4 py-2">
                <p class="text-uppercase">Modeled MPH PK curves with and without SA MPH <br class="d-none d-lg-block" />
                    supplementation compared with JORNAY
                    PM<sup>5</sup></p>
                <img class="d-none d-lg-block" src="../../assets/img/smooth-pk/smooth-pk-chart.png"
                    alt="Smooth Pk Chart">

                <div class="d-block d-lg-none" @mouseleave="restoreZoomIcon" @click="tapIcon">
                    <img v-if="showZoomIcon" src="../../assets/img/smooth-pk/smooth-pk-chart-mobile.png"
                        alt="Smooth Pk Chart" @wheel="hideZoomIcon" class="zoomable-image" />

                    <!-- Image without zoom icon -->
                    <img v-else src="../../assets/img/smooth-pk/smooth-pk-chart-mobile-noicon.png" alt="Smooth Pk Chart"
                        class="zoomable-image" />

                </div>
            </div>

            <div class="content my-3">
                <span class="footnote">
                    These data are modeled MPH PK curves of OROS<sup>®</sup> MPH and JORNAY PM.<sup>5</sup> <b> No
                        head-to-head
                        clinical PK or efficacy studies have been conducted and therefore data should be interpreted
                        with
                        caution.</b>
                </span>

            </div>

        </div>


        <div class="content py-5 middle-title p-0">
            <div class="container">
                <div class="middle-title_content ">
                    <h2 class="gtitle text-center fw-bold">JORNAY PM is designed to eliminate multiple peaks and troughs
                        from early morning to evening.<sup>5</sup> What would that mean for your patients?</h2>
                </div>
            </div>

        </div>

        <div class="container">
            <div class="content content_title mb-5">
                <span>DR=delayed-release; ER=extended-release; IR=immediate-release; MPH=methylphenidate; OROS=osmotic
                    release oral system; PK=pharmacokinetic; SA=short-acting.</span>
            </div>
        </div>

        <div class="smooth-video">
            <div class="container button-container">
                <h2 class="gtitle mb-3">
                    See JORNAY PM mechanism of delivery
                </h2>

                <!-- <VimeoModal videoId="930349754" channel="vimeo" /> -->

                <div class="featured-video">
                    <div class="video-wrapper">
                        <button class="play-btn" @click="playVideo()" v-if="!isPlaying">
                            <i class="fa fa-play"></i>
                        </button>
                        <iframe v-if="isPlaying" ref="vimeoPlayer" class="w-100 h-100"
                            src="https://player.vimeo.com/video/1168479228#t" frameborder="0"
                            allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
                        <img v-if="!isPlaying" src="../../assets/img/smooth-pk/smooth-video.png"
                            alt="Video about the Mechanism of Delivery for JORNAY PM">
                    </div>
                </div>
            </div>
            <section id="cta-content-smoothpk">
                <CTABanner :onlyBanner="true" :bannerData="{ bannerText: 'see dosing', href: '/dosing' }" />
            </section>
        </div>
    </section>
</template>



<script>
import Player from '@vimeo/player';
import CTABanner from "../CTABanner.vue";
import VimeoModal from "../../components/VimeoModal.vue";

export default {
    components: {
        VimeoModal,
        CTABanner
    },
    data() {
        return {
            isPlaying: false,
            player: null,
            showZoomIcon: true,
            timeoutId: null,
        }
    },
    methods: {
        playVideo() {
            this.isPlaying = true;
            this.$nextTick(() => {
                this.initVimeoPlayer();
            });
        },
        initVimeoPlayer() {
            this.$nextTick(() => {
                // let curretTime = sessionStorage.getItem("time") ? sessionStorage.getItem("time") : 0;
                if (this.$refs.vimeoPlayer) {
                    this.player = new Player(this.$refs.vimeoPlayer);
                    // this.player.setCurrentTime(curretTime)

                    this.player.play();
                    this.player.on('play', () => {
                    });
                    this.player.on('pause', () => {
                        // this.isPlaying = false;
                    });


                    // this.player.on('timeupdate', function (data) {
                    //     sessionStorage.setItem("time", data.seconds);
                    // });
                }
            });
        },
        hideZoomIcon() {
            this.showZoomIcon = false;
            clearTimeout(this.timeoutId);
        },
        restoreZoomIcon() {
            this.timeoutId = setTimeout(() => {
                this.showZoomIcon = true;
            }, 500);
        },
        tapIcon() {
            this.showZoomIcon = false;
        }
    },


}
</script>